import { useAtomValue } from "jotai";
import { Fragment } from "react";
import { colors } from "theme";

import ClientTranslation from "components/ClientTranslation";
import Text from "components/Text";

import { clientConfigAtom } from "atoms/clientConfig";
import { useClientTranslation } from "hooks/useClientTranslation";
import { COST_BREAKDOWN_LABELS, CostBreakdown } from "types/Estimate";

import { useStyles } from "./styles";

interface PricesProps {
  totalIncludingTax: string;
  totalExcludingTax: string;
  breakdown: CostBreakdown;
}

export const Prices = ({ totalExcludingTax, totalIncludingTax, breakdown }: PricesProps) => {
  const { classes } = useStyles();
  const { estimate: estimateConfig, enablePayeeJourney } = useAtomValue(clientConfigAtom);
  const { t } = useClientTranslation();

  const filterOutDeductible = ([item, value]: [string, string | null]): boolean => {
    if (item === "deductible") {
      return value !== null;
    } else {
      return true;
    }
  };

  return (
    <div className={classes.estimateGrid}>
      { (estimateConfig?.repairable?.showTotalPrice || enablePayeeJourney) && (
        <Fragment>
          <Text dataTestId="repairableCost" sizeVariant="lg" weight={400}>
            { estimateConfig?.repairable?.includeTaxInTotal ? (
              <ClientTranslation i18nKey="estimate.total_offer.incl_VAT">
                {t("estimate.total_offer.incl_VAT")}
              </ClientTranslation>
            ) : (
              <ClientTranslation i18nKey="estimate.total_offer.excl_VAT">
                {t("estimate.total_offer.excl_VAT")}
              </ClientTranslation>
            )}
          </Text>

          <Text sizeVariant="xl" weight={500} style={{ justifySelf: "end" }} dataTestId="totalCost">
            {estimateConfig?.repairable?.includeTaxInTotal ? totalIncludingTax : totalExcludingTax}
          </Text>
        </Fragment>
      )}

      { estimateConfig?.repairable?.showBreakdown &&
        Object.entries(breakdown)
          .filter(filterOutDeductible)
          .map(([item, cost]) => {
            const isDeductible = item === "deductible";
            const costBreakdownLabel = t(COST_BREAKDOWN_LABELS[item as keyof CostBreakdown]);

            return (
              <Fragment key={item}>
                <Text sizeVariant="md">{costBreakdownLabel}</Text>
                <Text
                  sizeVariant="md"
                  style={{
                    justifySelf: "end",
                    color: isDeductible ? colors.blue[40] : undefined,
                  }}
                >
                  {isDeductible ? "-" : ""}
                  {cost}
                </Text>
              </Fragment>
            );
          })}
    </div>
  );
};
